// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_home_home_module_ts":"2e7ac73c327d8539","src_app_confirmation-success_confirmation-success_module_ts":"a31718a6a7ab6e84"}[chunkId] + ".js";
};